/**
 * @desc 导入货架信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/storageUnit/importStorageUnitList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
